import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import IRQuestionnairesListing from "../../../components/SidebarMenuComponents/OAComponent/IRQuestionnairesListing";
import IRQuestionnairesDetailsComponent from "../../../components/SidebarMenuComponents/OAComponent/IRQuestionnairesDetailsComponent";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function IRQuestionnairesDetailsPage() {
    const location = useLocation();
    const copyQuestionariesData = location.state;
    return (
        <Page title=" IR Questionnaires Details| tiketic" >
            
            <StickyHeader title="IR Questionnaires Details" />
            <ContentStyle>
                <IRQuestionnairesDetailsComponent copyQuestionariesData={copyQuestionariesData} />
            </ContentStyle>
        </Page>
    );
}

